import { InviteJoinReason, SignUpTrackReason } from '../models/enums';

export const inviteReasons: Record<InviteJoinReason, SignUpTrackReason> = {
  [InviteJoinReason.OWNER_INVITE_BUILDER]: SignUpTrackReason.OWNER_SIGN_UP,
  [InviteJoinReason.EMPLOYEE_INVITE_DIRECTOR]: SignUpTrackReason.EMPLOYEE_SIGN_UP,
  [InviteJoinReason.EMPLOYEE_INVITE_PARTNER]: SignUpTrackReason.EMPLOYEE_SIGN_UP,
  [InviteJoinReason.EMPLOYEE_INVITE_SOLE_TRADER]: SignUpTrackReason.EMPLOYEE_SIGN_UP,
  [InviteJoinReason.EMPLOYEE_INVITE_TRUSTEE]: SignUpTrackReason.TRUSTEE_COMPANY_EMPLOYEE_SIGN_UP,
};
